import { useEffect, useRef } from "react";

export default function Availability() {
  const containerRef = useRef(null);
  const mountRef = useRef(null);

  useEffect(() => {
    document.title = "Availability – Heartland Property Solutions";
    if (!containerRef.current) return;

    // clear old content
    containerRef.current.innerHTML = "";

    // create mount node
    const mount = document.createElement("div");
    mount.id = "appfolio-listings";
    containerRef.current.appendChild(mount);
    mountRef.current = mount;

    // load script
    const script = document.createElement("script");
    script.src =
      "https://heartlandpropertysolutions.appfolio.com/javascripts/listing.js";
    script.async = true;

    script.onload = () => {
      if (window.Appfolio && mountRef.current) {
        window.Appfolio.Listing({
          hostUrl: "heartlandpropertysolutions.appfolio.com",
          themeColor: "#1E2A38",
          height: "800px",
          width: "100%",
          defaultOrder: "date_posted",
          element: mountRef.current,
          target: "#appfolio-listings",
          container: "#appfolio-listings",
        });
      }
    };

    containerRef.current.appendChild(script);

    // cleanup
    return () => {
      if (containerRef.current) containerRef.current.innerHTML = "";
      // remove any lingering AppFolio iframe from DOM
      const iframes = document.querySelectorAll('iframe[src*="appfolio.com"]');
      iframes.forEach((iframe) => iframe.remove());
    };
  }, []);

  return (
    <section className="mx-auto max-w-6xl px-6 py-16">
      <h1 className="mb-6 text-4xl font-bold text-brand-black">Availability</h1>
      <div ref={containerRef} className="relative z-0 overflow-visible" />
    </section>
  );
}
